import { render, staticRenderFns } from "./Terms_conditions.vue?vue&type=template&id=3857d2b9"
import script from "./Terms_conditions.vue?vue&type=script&lang=js"
export * from "./Terms_conditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports